import { useEffect, useState, useCallback } from "react";
import api, { fmtDate } from "../lib/api";
import { useI18n } from "../context/I18nContext";
import { PageHeader, StatusBadge, Empty } from "../components/common";
import { Input } from "../components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";

export default function Serials() {
  const { t } = useI18n();
  const [rows, setRows] = useState([]);
  const [q, setQ] = useState("");
  const [status, setStatus] = useState("all");

  const load = useCallback(() => {
    const params = {};
    if (q) params.serial = q;
    if (status !== "all") params.status = status;
    api.get("/serials", { params }).then((r) => setRows(r.data));
  }, [q, status]);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="serials-page">
      <PageHeader title={t("sn.title")} subtitle={t("sn.subtitle")} />
      <div className="flex gap-2 mb-4">
        <Input placeholder={t("sn.search")} value={q} onChange={(e) => setQ(e.target.value)}
          className="rounded-none h-8 text-xs max-w-64" data-testid="serials-search-input" />
        <Select value={status} onValueChange={setStatus}>
          <SelectTrigger className="rounded-none h-8 text-xs w-44" data-testid="serials-status-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">{t("common.all")}</SelectItem>
            <SelectItem value="in_stock">{t("st.in_stock")}</SelectItem>
            <SelectItem value="shipped">{t("st.shipped")}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      {rows.length === 0 ? <Empty text={t("common.noData")} /> : (
        <div className="tbl-wrap" data-testid="serials-table">
          <table className="tbl">
            <thead><tr>
              <th>{t("sn.serial")}</th><th>{t("common.item")}</th><th>{t("common.warehouse")}</th>
              <th>{t("loc.bin")}</th><th>{t("common.status")}</th>
              <th>{t("sn.receipt")}</th><th>OC</th><th>{t("sn.shippedDoc")}</th><th>{t("common.date")}</th>
            </tr></thead>
            <tbody>
              {rows.map((s) => (
                <tr key={s.id}>
                  <td className="font-bold">{s.serial}</td>
                  <td>{s.item_number}</td>
                  <td>{s.warehouse}</td>
                  <td>{s.location || "—"}</td>
                  <td><StatusBadge status={s.status} /></td>
                  <td>{s.receipt_number}</td>
                  <td>{s.po_number}</td>
                  <td>{s.shipped_doc || "—"}</td>
                  <td className="text-muted-foreground">{fmtDate(s.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
